import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { StorageService } from '../shared/services/base/storage.service';
import { SnackbarService } from '../shared/services/base/snackbar.service';
import { TranslationService } from '../shared/services/base/translation.service';
import { AuthService } from '../shared/services/data/auth.service';

const PUBLIC_ROUTES = ['/login', '/external-access', '/changePassword'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const snackbarService = inject(SnackbarService);
  const translationService = inject(TranslationService);
  const authService = inject(AuthService);

  if (req.url.includes('/assets/')) {
    return next(req);
  }

  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return next(req);
  }

  if (!storage.isAuthenticated()) {
    const currentPath = window.location.pathname;
    const isPublicRoute = PUBLIC_ROUTES.some(route => currentPath.includes(route));

    if (!isPublicRoute) {
      authService.logout();
    }
    return next(req);
  }

  const token = storage.get<string>('token');

  const cloned = req.clone({
    setHeaders: {
      Authorization: `${token}`,
    },
  });

  return next(cloned).pipe(
    tap((event: any) => {
      if (event?.body?.Result === 'E00026') {
        snackbarService.error(event?.body?.Message || translationService.instant('errors.sessionExpired'));
        authService.logout();
      }
    }),
  );
};
